import { computed } from 'vue'
import { useWindowSize } from '@vueuse/core'

export const useScreen = () => {
  const { width } = useWindowSize()
  const isMobileView = computed(() => width.value < 960)
  return { isMobileView }
}
